<template>
    <div>
        <card-header title="Edit Required Component" icon="fa-pencil"/>

        <card-body>
            <card-list>
                <subheader-list-item icon="fa-tasks" title="Complete Options"/>

                <container-list-item padded no-border>
                    <b-field><b-switch v-model="item.require_approval" true-value="1" false-value="0">Require approval.</b-switch></b-field>
                    <b-field><b-switch v-model="item.require_signature" true-value="1" false-value="0">Require signature.</b-switch></b-field>
                </container-list-item>

            </card-list>

        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteItem"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Required Component?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!course.title"
                    >
                        <i class="fas fa-check mr-2"></i>Save
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../http_client';
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import async from "async";

    export default {
        components: {ContainerListItem, SeparatorListItem, SubheaderListItem, CardListItem, CourseForm, NavigationListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                item: {},
                course: {outline: []},
                confirmDelete: false,
                dirty: null,
                reqTimeToggle: false,
                reqScoreToggle: false
            };
        },
        methods: {
            load: function() {
                this.$emit('loading', true);
                async.series([
                    (cb) => {
                        http.get('courses/new/' + this.props.courseId, {force: true}).then(response => { // TODO: temporary endpoint
                            if (!response.data.outline) response.data.outline = []; //TODO temp
                            this.course = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    },
                    (cb) => {
                        http.get('required-components/' + this.props.requiredId, {force: true}).then(response => {
                            this.item = response.data;

                            if (this.item.require_min_time > 0) this.reqTimeToggle = true;
                            if (this.item.quiz_min_score > 0) this.reqScoreToggle = true;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                });
            },
            submit: function() {
                this.$emit('loading', true);
                http.put('required-components/' + this.props.requiredId, this.item, {force: true}).then(response => {
                    this.$reloadCard('edit-course', {courseId: this.props.courseId});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            deleteItem() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);
                    console.log('do delete');
                    http.delete('required-components/' + this.props.requiredId, {force: true}).then(response => {
                        this.$reloadCard('edit-course', {courseId: this.props.courseId});
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.courseId': function() {
                this.dirty = null;
                this.load();
            },
            'item': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this item? Unsaved changes will be lost.');
                }
            },
            'reqTimeToggle': function() {
                if (this.reqTimeToggle === false) this.item.require_min_time = 0;
                if (this.reqScoreToggle === false) this.item.quiz_min_score = 0;
            }
        },
        mounted() {
            this.load();
        }
    };
</script>
